import type { ValueOf } from '@shared/types/utilities';

export const PAYMENT_METHODS = {
  cash: 'CASH',
  card: 'CARD',
  bankTransfer: 'BANK_TRANSFER',
  ewalletTransfer: 'E_WALLET_TRANSFER',
} as const;

export type TPaymentMethod = ValueOf<typeof PAYMENT_METHODS>;
